module.exports = __webpack_public_path__ + "static/media/ios-crop.56ec7f79.svg";